<template>
  <generic-trash
    v-model="selected"
    :getPag="getPagAux"
    :getExcel="getExcelAux"
    :getParams="getParamsAux"
    :doRestore="doRestoreAux"
    :doDelete="doDeleteAux"
    :FilterPanel="FilterPanel"
    :RouteName="RouteName"
    :dialogTitle="dialogTitle"
    :dialogMesage="dialogMesage"
    :ExcelName="ExcelName"
    :idVista="idVista"
    :HeaderTitle="HeaderTitle"
    :vuexnamespace="vuexnamespace"
    :PayloadSingleId="PayloadSingleId"
    :PayloadMultipleId="PayloadMultipleId"
  />
</template>

<script>
import { i18n } from '@/i18n'
import GenericTrash from '@/views/trash/GenericTrash.vue'
import CustomFilter from '@/components/filters/trash/ProductsFilter.vue'
import { getProductsPag } from '@/services/configurations/getProductsPag'
import { getProductsExcel } from '@/services/configurations/getProductsExcel'
import { deleteTrashProducto } from '@/services/trash/deleteTrashProducto'
import { restoreTrashProducto } from '@/services/trash/restoreTrashProducto'

export default {
  name: 'vista-papelera-productos',
  components: {
    GenericTrash,
  },
  data: function () {
    return {
      FilterPanel: CustomFilter,
      RouteName: 'products',
      dialogTitle: 'Borrar productos',
      dialogMesage: '¿Estás seguro que deseas borrar de forma permanente los productos seleccionados?',
      ExcelName: 'productos-borrados.xlsx',
      idVista: 69,
      HeaderTitle: i18n.t('trash.products'),
      vuexnamespace: 'trashProducts',
      PayloadSingleId: 'idProducto',
      PayloadMultipleId: 'idProductos',
      selected: []
    }
  },
  methods: {
    getParamsAux (applyFilters = false) {
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      if (applyFilters) this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      return {
        ItemDescription: data.ItemDescription ? data.ItemDescription.value : null,
        UnitOfMeasure: data.UnitOfMeasure ? data.UnitOfMeasure.value : null,
        UnitPriceWithoutTaxMin: data.UnitPriceWithoutTaxMin ? data.UnitPriceWithoutTaxMin.value : null,
        UnitPriceWithoutTaxMax: data.UnitPriceWithoutTaxMax ? data.UnitPriceWithoutTaxMax.value : null,
        ArticleCode: data.ArticleCode ? data.ArticleCode.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        borrados: true,
      }
    },
    getPagAux: async function (objOrder, params) {
      return await getProductsPag(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      return await getProductsExcel(objOrder, params)
    },
    doRestoreAux: async function (payload) {
      return await restoreTrashProducto(payload)
    },
    doDeleteAux: async function (payload) {
      return await deleteTrashProducto(payload)
    },
  }
}
</script>
